import { MachineGuards } from 'common/bento/types/MachineConfig';
import canEditPersonalInformation from 'features/Onboarding/lib/canEditPersonalInformation';
import { ApplicationType } from 'features/Onboarding/types';

import { FRANCE_COUNTRY_CODE } from '../../../../Bento/libs/constants';
import { Model } from './model';

export enum Guard {
  CanEditComplianceInformation = 'canEditComplianceInformation',
  IsForeignTaxResidencyNotAllowed = 'isForeignTaxResidencyNotAllowed',
  IsMissingFiscalId = 'isMissingFiscalId',
  IsNotEligibleToOnboard = 'isNotEligibleToOnboard',
  IsSpecifiedUSPerson = 'isSpecifiedUSPerson',
}

const guards: MachineGuards<Model, Guard> = {
  canEditComplianceInformation: ({ getModuleData }) => {
    const { companyUser, companyUsers, isNewOnboardingAllowed } =
      getModuleData().complianceData.viewer;

    return canEditPersonalInformation({
      companyUser: companyUser || null,
      companyUsers: companyUsers || null,
      isNewOnboardingAllowed,
    });
  },

  isForeignTaxResidencyNotAllowed: ({ getModuleData }) => {
    const { applicationType, complianceData } = getModuleData();

    const hasForeignTaxResidency = !!complianceData.viewer.taxResidencies.find(
      ({ country }) => country !== FRANCE_COUNTRY_CODE,
    );

    return (
      hasForeignTaxResidency && applicationType !== ApplicationType.Standard
    );
  },

  isMissingFiscalId: ({ getModuleData }) => {
    const foreignTaxResidencies =
      getModuleData().complianceData.viewer.taxResidencies.filter(
        ({ country }) => country !== FRANCE_COUNTRY_CODE,
      );

    return foreignTaxResidencies.some((taxResidency) => !taxResidency.fiscalId);
  },

  isNotEligibleToOnboard: ({ getModuleData }) => {
    return !getModuleData().complianceData.viewer.profile.isEligibleToOnboard;
  },

  isSpecifiedUSPerson: ({ getModuleData }) => {
    return (
      getModuleData().complianceData.viewer.profile.isSpecifiedUSPerson === true
    );
  },
};

export default guards;
